var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.displayPriceInfo)?_c('div',{staticClass:"suggested-retail-price uk-text-small uk-text-muted"},[_c('span',[_vm._v(" "+_vm._s(_vm.srpText)+" "+_vm._s(_vm.displayPriceInfo.currency)+" "+_vm._s(_vm.price)+" "+_vm._s(_vm.incvatText)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }